import React from 'react';
import {SelectModel} from "../../../../../app/types/SelectModel";
import cl from "../../AccessSettings/AccessSettings.module.css";
import GridFilterPanelLayoutCollapse
    from "../../../../uiLayouts/GridFilterPanelLayout/components/GridFilterPanelLayoutCollapse/GridFilterPanelLayoutCollapse";
import {useTranslation} from "react-i18next";
import FilterPanelResponsibleVisibilityFilterContent from "./ResponsibleVisibilityFilterFilterContent";
import Icon from "../../../../../assets/icon/Icon";

type FilterPanelResponsibleVisibilityFilterProps = {
    id: string;
    disabled?: boolean;
    onClear: (value?: string) => void;
    onChange: (value: Array<SelectModel>) => void,
    value: Array<SelectModel>;
}

const FilterPanelResponsibleVisibilityFilter: React.FC<FilterPanelResponsibleVisibilityFilterProps> = ({
                                                                                 id,
                                                                                 value,
                                                                                 disabled,
                                                                                 onClear,
                                                                                 onChange
                                                                             }) => {
    const {t} = useTranslation();

    return (
        <GridFilterPanelLayoutCollapse titleBold={false}
                                       defaultExpanded={false}
                                       showSeparationHeaderLine={false}
                                       hideOnFilterPanelLayoutContextClear={true}
                                       style={{margin: '5px 0 10px 0'}}
                                       title={
                                           <>
                                               <div>
                                                   {t("shared.labels.responsible-visibility-label")}
                                               </div>
                                               <div>
                                                   {value.length > 0
                                                       ? <Icon icon={"faTrash"}
                                                               className={cl.trash}
                                                               onClick={(ev) => {
                                                                   ev.stopPropagation();

                                                                   if (disabled) {
                                                                       return;
                                                                   }

                                                                   onClear();
                                                               }}/>
                                                       : null
                                                   }
                                               </div>
                                           </>
                                       }>
            {({isExpanded}) =>
                <div>
                    {isExpanded
                        ? <FilterPanelResponsibleVisibilityFilterContent id={id}
                                                            onClear={onClear}
                                                            onChange={onChange}
                                                            value={value}/>
                        : <div style={{height: '250px'}}>
                        </div>
                    }
                </div>
            }
        </GridFilterPanelLayoutCollapse>
    );
};

export default FilterPanelResponsibleVisibilityFilter;